const ArgumentType = require('../extension-support/argument-type');
const BlockType = require('../extension-support/block-type');
const Cast = require('../util/cast');

class Scratch3ControllerPlus {
    constructor(runtime) { this.runtime = runtime; this._keys = {}; this._last = ''; var self = this; document.addEventListener('keydown', function(e) { self._keys[e.key.toLowerCase()] = true; self._last = e.key; }); document.addEventListener('keyup', function(e) { self._keys[e.key.toLowerCase()] = false; }); }
    getInfo() {
        return {
            id: 'controllerPlus', name: '🎮 コントローラー+', color1: '#FF6680', color2: '#FF4D6A',
            blocks: [
                { opcode: 'keyDown', blockType: BlockType.BOOLEAN, text: '[K] キーが押されている？', arguments: { K: { type: ArgumentType.STRING, defaultValue: 'a' } } },
                { opcode: 'lastKey', blockType: BlockType.REPORTER, text: '最後に押されたキー' },
                { opcode: 'anyKeyDown', blockType: BlockType.BOOLEAN, text: '何かキーが押されている？' }
            ]
        };
    }
    keyDown(args) { return this._keys[Cast.toString(args.K).toLowerCase()] || false; }
    lastKey() { return this._last; }
    anyKeyDown() { return Object.values(this._keys).some(function(v) { return v; }); }
}
module.exports = Scratch3ControllerPlus;